import React from "react";

const Container: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className="m-auto max-w-[1320px] px-[20px] sm:px-[28px] md:px-[40px] lg:px-[52px] xl:px-[20px]">
      {children}
    </div>
  );
};

export default Container;
